@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ListPopOut {
  @extend %font-family-primary;

  width: 608px;
  max-height: 400px;
  border-radius: 8px;
  overflow: auto;
  padding: 16px;

  &.noFixWidth {
    width: auto;
  }
}
